"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var _classnames = _interopRequireDefault(require("classnames"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var Button = function Button(_ref) {
  var _cx;

  var active = _ref.active,
      className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      children = _ref.children,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? 'default' : _ref$kind,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["active", "className", "type", "children", "disabled", "kind"]);
  var theme = (0, _ThemeProvider.useTheme)();
  var classes = useStyles({
    theme: theme
  });
  return /*#__PURE__*/React.createElement("button", (0, _extends2["default"])({}, rest, {
    disabled: disabled,
    className: (0, _classnames["default"])(classes.Button, "kind-".concat(kind), (_cx = {
      active: active
    }, (0, _defineProperty2["default"])(_cx, classes.Error, rest['data-has-errors']), (0, _defineProperty2["default"])(_cx, classes.Warning, rest['data-has-warnings']), (0, _defineProperty2["default"])(_cx, classes.Disabled, disabled), _cx), className),
    type: type
  }), children);
};

exports["default"] = Button;

function addProps(additionalProps) {
  return function ButtonWithProps(props) {
    return /*#__PURE__*/React.createElement(Button, (0, _extends2["default"])({}, props, additionalProps));
  };
}

Button.Main = addProps({
  kind: 'main'
});
Button.Secondary = addProps({
  kind: 'secondary'
});
Button.Negative = addProps({
  kind: 'negative'
});
Button.Lite = addProps({
  kind: 'lite'
});
//# sourceMappingURL=index.js.map